import { useMutation } from '@tanstack/react-query';

import {
  deleteV1RequestToJoinById,
  postV1User,
  type UserPostBody,
} from '../../../api/generated/pap';
import {
  invalidateCurrentBusinessPartnerDivisionRequests,
  invalidateCurrentBusinessPartnerDivisions,
} from '../../Divisions/divisions.queries';

/**
 * Mutation hooks for reviewing Requests to Join the current Business Partner.
 * See `../../Settings/IdentityProviders/identityProviders.mutations.ts` for
 * the pattern.
 */

/** Accepting a request means creating the requester as a User with the chosen profiles. */
export const useAcceptRequestToJoin = () =>
  useMutation({
    mutationFn: async (payload: UserPostBody) => {
      const { data } = await postV1User({ body: payload, throwOnError: true });
      return data;
    },
  });

/**
 * Decline a Request to Join (or, from the Overview, cancel the identity's own
 * request by id). Membership changes what Divisions are visible, so the
 * Divisions reads are cleared.
 */
export const useCancelRequestToJoin = () =>
  useMutation({
    mutationFn: async (id: string) => {
      await deleteV1RequestToJoinById({ path: { id }, throwOnError: true });
    },
    onSuccess: () => {
      invalidateCurrentBusinessPartnerDivisions();
      invalidateCurrentBusinessPartnerDivisionRequests();
    },
  });
